class PageTop {
  constructor(el, opt) {
    this.el = el;
    this.mvSwiperEle = '.js-mv-swiper';
    if ($(this.mvSwiperEle).length > 0) {
      this.mvSwiper();
    }
    this.newsTextSwiperEle = '.js-news-text-swiper';
    if ($(this.newsTextSwiperEle).length > 0) {
      this.newsTextSwiper();
    }
    this.newsSwiperEle = '.js-news-swiper';
    if ($(this.newsSwiperEle).length > 0) {
      this.newsSwiper();
    }
    this.mvTextEle = '.js-mv-text';
    if ($(this.mvTextEle).length > 0) {
      this.mvTextAnime();
    }
    this.ttlAnimeEle = '.js-ttl-anime';
    if ($(this.ttlAnimeEle).length > 0) {
      this.ttlAnime();
    }
  }
  mvSwiper() {
    new Swiper(this.mvSwiperEle, {
      loop: true,
      effect: "fade",
      allowTouchMove: false,
      speed: 1500,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    })
  }
  newsTextSwiper() {
    new Swiper(this.newsTextSwiperEle, {
      loop: true,
      allowTouchMove: false,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true
      },
      direction: 'horizontal', // 水平方向
    })
  }
  newsSwiper() {
    new Swiper(this.newsSwiperEle, {
      loop: true,
      allowTouchMove: false,
      speed: 7000,
      slidesPerView: 2,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        '768': {
          slidesPerView: 4,
        }
      }
    })
  }
  mvTextAnime() {
    let $container = $('.js-mv-text');

    $container.each(function() {
      let html = $(this).html();
      let wrappedText = '';

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<' && html.substring(i, i + 4) === '<br>') {
          wrappedText += '<br>';
          i += 3; // skip the '<br>' tag
        } else {
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });

    let tl = gsap.timeline();
    
    tl
    .fromTo(".js-mv-en", {
      opacity: 0,
      y: 20,
    },{
      opacity: 1,
      y: 0,
    })
    .to(".js-mv-text", 1,{
      opacity: 1,
    },)
    .fromTo(".js-mv-text span",{
      opacity: 0,
      y: 30,
      duration: 1500,
    },{
      opacity: 1,
      y: 0,
      stagger: 0.1 // スタグアニメーションの間隔
    },'<=')
  }
  ttlAnime() {
    let $container = $('.js-ttl-anime');

    $container.each(function() {
      let html = $(this).html();
      let wrappedText = '';

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<' && html.substring(i, i + 4) === '<br>') {
          wrappedText += '<br>';
          i += 3; // skip the '<br>' tag
        } else {
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });

    let options = {
      threshold: [0.1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target.querySelectorAll('span');
        if(entry.intersectionRatio >= 0.05 && !entry.target.classList.contains('is-active')){
          gsap.fromTo(item,{
            opacity: 0,
            y: 30,
            duration: 500,
          },{
            opacity: 1,
            y: 0,
            stagger: 0.1 // スタグアニメーションの間隔
          })
          entry.target.classList.add('is-active');
        }
      });
    }, options);

    const inviewItem = document.querySelectorAll('.js-ttl-anime');

    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
  }
}
